module.exports = __webpack_public_path__ + "media/flags/om-056b3102.svg";